import React from 'react';
import Layout from '../Layout';
import { Container, Box, Grid } from '@material-ui/core';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
// import "../BreakDown/Breakdown.css";
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';

const DataManagement = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' }
    ];

    const handler = (route) => {
        navigate(route)
    }
    return (
        <Layout>
            <Container>
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Data Management" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/data-management/upload-data")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CloudUploadIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Upload Data
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/data-management/download-data")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CloudDownloadIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Download Data
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                    {/* <Grid container spacing={4}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/pm/log-overview")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PersonAddIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Add Department
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/pm/log-overview")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <GroupIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        View Departments
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid> */}
                </Box>
            </Container>
        </Layout>
    );
};

export default DataManagement;
